module.exports = __webpack_public_path__ + "img/logo-sc-compac.d871f0d8.png";